import { Injectable } from '@angular/core';
import { ProfilePermissionListModel } from '../models/profile.models';

@Injectable()
export class PermissionService {
    
    private permissions: Array<ProfilePermissionListModel>; // Store the actions for which this user has permission

    hasPermission(authGroup: string): boolean {
        return this.permissions && this.permissions
            .find(perm => perm.SectionName === authGroup).Allowed;
    }

    public getPermissions(): ProfilePermissionListModel[] {
        return this.permissions;
    }

    setPermissions(perms: ProfilePermissionListModel[]): void {
        this.permissions = perms;
    }
}